import { render, staticRenderFns } from "./VasionUserGroupSelect.vue?vue&type=template&id=c35e487a&scoped=true&"
import script from "./VasionUserGroupSelect.vue?vue&type=script&lang=js&"
export * from "./VasionUserGroupSelect.vue?vue&type=script&lang=js&"
import style0 from "./VasionUserGroupSelect.vue?vue&type=style&index=0&id=c35e487a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c35e487a",
  null
  
)

export default component.exports